import axios from 'axios';
import config  from '../../config/environmentConfig';
import defaultConfig  from '../../config/defaults';
import {Utils} from "../../utils/utils";
import { inlineWidget } from "../inlineWidget";
import { reviewForm } from "../../utils/reviewForm";
import { brandConfig } from "../../brandConfig"
import {doc} from "prettier";
const FormData = require('form-data');

export class PostReview {
    deviceFingerprintingLoaded: boolean;
    ratingValue: string;
    allUploadedMedia;
    constructor() {
        this.deviceFingerprintingLoaded = false;
        this.ratingValue = ''
    }

    inlineUserFormHandler(element: HTMLElement): void{

        let $formDialogButton = element.querySelectorAll('.kr-inline-preview-button');
        $formDialogButton.forEach((item)=>{
            item.addEventListener('click', (e) => {
                //this.allUploadedMedia = [];
                reviewForm.prototype.allUploadedMedia = [];
                if (element.querySelector('.kr-inline-form-active')) {
                    if (element.querySelector('.kr-inline-form-active').classList.contains('kr-inline-form-active')) {
                        element.querySelector('.kr-inline-form-active').classList.remove('kr-inline-form-active');   
                    }   
                }
                item.closest('.kr-inline-form-review-container').classList.add('kr-inline-form-active');
            });
        })
        if(element.querySelector('.kr-back-to-formButton')){
            let $mediaWrapperClose = element.querySelectorAll('.kr-back-to-formButton');
            $mediaWrapperClose.forEach((item) => {
                item.addEventListener('click', (e) => {
                    item.closest('.kr-image-upload-wrapper').classList.add('kr-hide');   
                });  
            });  
        }
        if(element.querySelector('.kr-cancel-photo-button')){
            let $mediaWrapperClose = element.querySelectorAll('.kr-cancel-photo-button');
            $mediaWrapperClose.forEach((item) => {
                item.addEventListener('click', (e) => {
                    item.closest('.kr-image-upload-wrapper').classList.add('kr-hide');   
                });  
            });   
        }
        //if(element.querySelector('.kr-iniline-user-cancel-button')){
        let $userCancelButton = element.querySelector('.kr-iniline-user-cancel-button');
        $userCancelButton.addEventListener('click', (e) => {
            let $optionCheckbox = element.querySelectorAll('.kr-inline-checkbox');
            let errorHolder = element.querySelectorAll('.kr-error-holder');
            let signUpFields = element.querySelectorAll('.kr-show-if-brand');
            let textField = element.querySelectorAll('.kr-text-field');
            $optionCheckbox.forEach(item => {
                let newItem = item as HTMLInputElement;
                newItem.checked = false;
            });
            signUpFields.forEach(item => {
                item.classList.add('kr-hide');
            });
            textField.forEach(item => {
                let newItem = item as HTMLInputElement;
                newItem.value = '';
            });
            errorHolder.forEach(item => {
                item.classList.add('kr-hide');
            });
        });   
        //}
    }

    sendUserPostRequest(brand: string, locale: string, dataAttributes: object, element: HTMLElement) {
        let t = this,
        krButtonClickEventsSelector = element.querySelector('.kr-inline-user-button');
        const loginUserData = Utils.getLoginUserClientData();
        
        let $optinSection = (element.querySelector('.kr-inline-form-optin-section') as HTMLInputElement),
        $reviewSection = (element.querySelector('.kr-inline-review-form-container') as HTMLInputElement),
        $userSection = (element.querySelector('.kr-inline-user-detail') as HTMLInputElement),
        $userFormNickname = (element.querySelector('.kr-inline-nckName') as HTMLInputElement),
        $userFormEmail = (element.querySelector('.kr-inline-email') as HTMLInputElement),
        $userNickname = (element.querySelector('.kr-user-name') as HTMLElement),
        $userEmail = (element.querySelector('.kr-user-email') as HTMLElement),
        
        $progressBar = (element.querySelector('.kr-progress') as HTMLElement),
        $progressNumber = (element.querySelector('.kr-progressNum') as HTMLElement),
        $optionSaveButton = (element.querySelector('.kr-button-optin-save') as HTMLInputElement);
        
        krButtonClickEventsSelector.addEventListener('click', async (e) => {
            let el = this;
            let $rFname = (element.querySelector('.kr-inline-firstName') as HTMLInputElement),
            $rLname = (element.querySelector('.kr-inline-lastName') as HTMLInputElement),
            $rNname= (element.querySelector('.kr-inline-nckName') as HTMLInputElement),
            $rEmailSignUp =(element.querySelector('.kr-email-signup') as HTMLInputElement),
            $rEmailReview =(element.querySelector('.kr-email-review') as HTMLInputElement),
            $rULOptin = (element.querySelector('.kr-unilever-optin .kr-inline-checkbox') as HTMLInputElement),
            $rBOptin = (element.querySelector('.kr-brand-optin .kr-inline-checkbox') as HTMLInputElement);
            let nickNameData = '',
                prmData = {};
            prmData['brand'] = brand;
            prmData['locale'] = locale;
            dataAttributes['contributor'] = {};
            dataAttributes['contributor']['emailValidated'] = false;
            if (loginUserData && loginUserData['email']) {
                dataAttributes['contributor']['emailValidated'] = true;
            }
            prmData['termAndConditions'] = (element.querySelector('.kr-inline-termandconditions .kr-inline-checkbox') as HTMLInputElement).checked;
            if ($rULOptin && $rULOptin.checked) {
                prmData['unileverOptin'] = $rULOptin.checked;
                dataAttributes['isConsented'] = $rULOptin.checked
            }
            if ($rBOptin && $rBOptin.checked) {
                prmData['brandOptin'] = $rBOptin.checked;
            }
            if(($rBOptin && $rBOptin.checked)||(!$rBOptin && $rULOptin && $rULOptin.checked)) {
                if($rFname) {
                    prmData['firstname'] = $rFname.value;
                    dataAttributes['firstName'] = $rFname.value;
                }
                if($rLname) {
                    prmData['lastname'] = $rLname.value;
                    dataAttributes['lastName'] = $rLname.value;
                }
                if($rEmailSignUp) {
                    dataAttributes['contributor']['email'] = $rEmailSignUp.value;
                    prmData['email'] = $rEmailSignUp.value;
                } else if($rEmailReview) {
                    dataAttributes['contributor']['email'] = $rEmailReview.value;
                    prmData['email'] = $rEmailReview.value;
                }
                prmData['brandCode'] = (element.querySelector('.brand-code') as HTMLInputElement).value;
                prmData['campaignId'] = (element.querySelector('.campaign-id') as HTMLInputElement).value;
                prmData['x_api_key'] = (element.querySelector('.x_api_key') as HTMLInputElement).value;
                prmData['region'] = (element.querySelector('.signup-region') as HTMLInputElement).value;
            }else if($rEmailReview) {
                dataAttributes['contributor']['email'] = $rEmailReview.value;
                prmData['email'] = $rEmailReview.value;
            }
            if($rNname) {
                dataAttributes['contributor']['nickName'] = $rNname.value;
                nickNameData = $rNname.value;
            }
            if(this.checkFormValidation(Object.assign({}, dataAttributes, prmData), element)) {
                $optinSection.classList.add('kr-hide');
                $reviewSection.classList.remove('kr-hide');
                $userSection.classList.remove('kr-hide');
                $userNickname.innerText = $userFormNickname.value;
                $userEmail.innerText = $userFormEmail.value;
                $progressNumber.innerText = '50%';
                $progressBar.style.width = '50%';
                let prmDataResponse;
                if(prmData['brandOptin'] || prmData['unileverOptin']) {
                    //t.requestPRMSubmit(prmData);
                    try {
                        prmDataResponse = await t.requestPRMSubmit(prmData);
                    } catch (error) {
                        console.log(error);
                    }
                };
            }
            return;
        });
    }
    sendPostReviewRequest(brand: string, locale: string, dataAttributes: object, element: HTMLElement) {
        let t = this,
            entityId,
            krButtonClickEventsSelector = element.querySelectorAll('.kr-inline-review-button'),
            loader = element.querySelector('.kr-loader-overlay') as HTMLLIElement;
        const loginUserData = Utils.getLoginUserClientData();
        krButtonClickEventsSelector.forEach(item => {
            item.addEventListener('click', async (e) => {
                loader.classList.remove('kr-hide');
                let activeForm = item.closest('.kr-inline-form-active') as HTMLElement;
                let $rFname = (element.querySelector('.kr-inline-firstName') as HTMLInputElement),
                $rLname = (element.querySelector('.kr-inline-lastName') as HTMLInputElement),
                $rNname= (element.querySelector('.kr-inline-nckName') as HTMLInputElement),
                $rEmailSignUp =(element.querySelector('.kr-inline-email-signup') as HTMLInputElement),
                $rEmailReview =(element.querySelector('.kr-inlineemail-review') as HTMLInputElement),
                $rULOptin = (element.querySelector('.kr-inline-unilever-optin .kr-inline-checkbox') as HTMLInputElement),
                $rBOptin = (element.querySelector('.kr-inline-brand-optin .kr-inline-checkbox') as HTMLInputElement),
                
                $rTitle = (activeForm.querySelector('.kr-inline-reviewTitle') as HTMLInputElement),
                $rComment = (activeForm.querySelector('.kr-inline-reviewTxt') as HTMLInputElement),
                $ratingValue = (activeForm.querySelector('.inline-form-rating')) as HTMLInputElement,
                $entityUrl = (activeForm.querySelector('.inline-form-entity-url')) as HTMLInputElement,
                $entityName = (activeForm.querySelector('.inline-form-entity-name')) as HTMLInputElement,
                $entityImageUrl = (activeForm.querySelector('.inline-form-entity-image-url')) as HTMLInputElement,
                $entityType = (activeForm.querySelector('.inline-form-entity-type')) as HTMLInputElement,
                $parentEntityId = (activeForm.querySelector('.inline-form-parent-entity-id')) as HTMLInputElement,
                $formEntityId = (activeForm.querySelector('.inline-form-entity-id')) as HTMLInputElement;
                
                entityId = $formEntityId.value ? $formEntityId.value: '';
                let nickNameData = '', prmData = {};
                prmData['brand'] = brand;
                prmData['locale'] = locale;
                dataAttributes['contributor'] = {};
                dataAttributes['contributor']['emailValidated'] = false;
                if (loginUserData && loginUserData['email']) {
                    dataAttributes['contributor']['emailValidated'] = true;
                }
                dataAttributes['rating'] = $ratingValue.value ? $ratingValue.value : 0;
                dataAttributes['entityUrl'] = $entityUrl.value ? $entityUrl.value : '';
                dataAttributes['entityName'] = $entityName.value ? $entityName.value : '';
                dataAttributes['entityImageUrl'] = $entityImageUrl.value ? $entityImageUrl.value : '';
                dataAttributes['entityType'] = $entityType.value ? $entityType.value : 0;
                dataAttributes['parentEntityId'] = $parentEntityId.value ? $parentEntityId.value : '';

                prmData['termAndConditions'] = (element.querySelector('.kr-inline-termandconditions .kr-inline-checkbox') as HTMLInputElement).checked;
                if ($rULOptin && $rULOptin.checked) {
                    prmData['unileverOptin'] = $rULOptin.checked;
                    dataAttributes['isConsented'] = $rULOptin.checked
                }
                if ($rBOptin && $rBOptin.checked) {
                    prmData['brandOptin'] = $rBOptin.checked;
                }
                if(($rBOptin && $rBOptin.checked)||(!$rBOptin && $rULOptin && $rULOptin.checked)) {
                    if($rFname) {
                        prmData['firstname'] = $rFname.value;
                        dataAttributes['firstName'] = $rFname.value;
                    }
                    if($rLname) {
                        prmData['lastname'] = $rLname.value;
                        dataAttributes['lastName'] = $rLname.value;
                    }
                    if($rEmailSignUp) {
                        dataAttributes['contributor']['email'] = $rEmailSignUp.value;
                        prmData['email'] = $rEmailSignUp.value;
                    } else if($rEmailReview) {
                        dataAttributes['contributor']['email'] = $rEmailReview.value;
                        prmData['email'] = $rEmailReview.value;
                    }
                    prmData['brandCode'] = (element.querySelector('#brand-code') as HTMLInputElement).value;
                    prmData['campaignId'] = (element.querySelector('#campaign-id') as HTMLInputElement).value;
                    prmData['x_api_key'] = (element.querySelector('#x_api_key') as HTMLInputElement).value;
                    prmData['region'] = (element.querySelector('#signup-region') as HTMLInputElement).value;
                }else if($rEmailReview) {
                    dataAttributes['contributor']['email'] = $rEmailReview.value;
                    prmData['email'] = $rEmailReview.value;
                }
                if($rNname) {
                    dataAttributes['contributor']['nickName'] = $rNname.value;
                    nickNameData = $rNname.value;
                }

                if($rTitle) {
                    dataAttributes['reviewTitle'] = $rTitle.value;
                }
                if($rComment) {
                    dataAttributes['reviewComment'] = $rComment.value;
                }
                if (this.checkReviewFormValidation(Object.assign({}, dataAttributes, prmData), element)) {
                    let krButtonLoaderSelector = element.querySelector('.kr-submit-form-button .kr-button-loader');
                    krButtonLoaderSelector.classList.remove('kr-hide');
                    item.setAttribute("style", "color:#999;");
                    item.setAttribute('disabled', "true");
                    this.allUploadedMedia = reviewForm.prototype.getAllUploadMediaData();

                    if (this.allUploadedMedia && this.allUploadedMedia.length) {
                        await this.getMediaDataForUploadedImages(brand, locale, entityId)
                            .then(mediaData => {
                                dataAttributes['reviewMedia'] = mediaData;
                            });
                    }
                    if (dataAttributes.hasOwnProperty('entityId')) {
                        delete dataAttributes['entityId'];
                    }
                    if (dataAttributes.hasOwnProperty('entityList')) {
                        delete dataAttributes['entityList'];
                    }
                    t.deviceFingerprinting(element).then(() => {
                        const $deviceFingerPrint = (document.querySelector('#rrBlackBox') as HTMLInputElement);
                        let timer, count = 0;
                        timer = setInterval(function () {
                            if (($deviceFingerPrint.value && $deviceFingerPrint.value !== '') || count > 20) {
                                clearInterval(timer);
                                dataAttributes['deviceMetaData'] = {};
                                dataAttributes['deviceMetaData']['userAgent'] = Utils.getDeviceUserAgent()['userAgent'];
                                dataAttributes['deviceMetaData']['referer'] = window.location.origin;
                                dataAttributes['deviceMetaData']['deviceFingerPrint'] = $deviceFingerPrint.value;
                                axios({
                                    method: 'post',
                                    url: config.url + '/reviews/' + brand + '/' + locale + '/' + entityId,
                                    data: dataAttributes,
                                    headers: {
                                        'x-api-key': brandConfig.apikey
                                    },
                                    validateStatus: function (status) {
                                        return status >= 200 && status <= 400; // default; // Resolve only if the status code is less than 500
                                    }
                                }).then((response) => {
                                    element.querySelector('.kr-inline-form-active .kr-inline-preview-button').classList.add('kr-hide');
                                    element.querySelector('.kr-inline-form-active .kr-inline-preview-thanks-message').classList.remove('kr-hide');
                                    element.querySelector('.kr-inline-form-active .kr-inline-preview-success-icon').classList.remove('kr-hide');
                                    let ratingBox = element.querySelector('.kr-inline-form-active .kr-aggregateRating') as HTMLLIElement;
                                    ratingBox.style.setProperty('--rating', dataAttributes['rating']);
                                    element.querySelector('.kr-inline-form-active').classList.remove('kr-inline-form-active');
                                    loader.classList.add('kr-hide');
                                }).catch((error) => {
                                    console.error("error", error);
                                    loader.classList.add('kr-hide');
                                });
                            }
                            count++;
                        }, 100)

                    })

                } else {
                    loader.classList.add('kr-hide');
                }
                return;
            });
        });
    }

    // KQ device fingerprinting integration
    deviceFingerprinting(element: HTMLElement): Promise<any> {
        try {
            return new Promise((resolve) =>{
                if (this.deviceFingerprintingLoaded) return resolve(false);

                if (!this.deviceFingerprintingLoaded) {
                    this.deviceFingerprintingLoaded = true;
                    let $rrBlackBox = document.querySelector('#rrBlackBox');
                    if($rrBlackBox) {
                        ($rrBlackBox as HTMLInputElement).remove();
                    }
                    document.body.insertAdjacentHTML('beforeend', '<input type="hidden" name="rrBlackBox" id="rrBlackBox"/>');

                    // Configurations must be on page before snare.js
                    window['io_bbout_element_id'] = 'rrBlackBox',   // Populate #blackBox input with device fingerprint
                    window['io_install_stm'] = false,          // do not install Active X
                    window['io_exclude_stm'] = 12,             // do not run Active X
                    window['io_install_flash'] = false,          // do not install Flash
                    window['io_enable_rip'] = true,           // collect Real IP information
                    window['io_min_flash_version'] = 3000;

                    let el = document.createElement('script');
                    el.type = 'text/javascript';
                    el.src = 'https://mpsnare.iesnare.com/snare.js';
                    document.body.appendChild(el);
                    resolve(true);
                }
            })
        } catch (e) {
            console.error(e);
        }
        return;
    };

    selectRating(element: HTMLElement): void{
        let uRatingSelector = element.querySelectorAll('.starRatingsContainer input'),
            inlineRating = element.querySelector('.inline-form-rating') as HTMLInputElement;
        
        if(uRatingSelector) {
            uRatingSelector.forEach(item => {
                item.addEventListener('click', (event) => {
                    let parentElement = item.closest('.kr-inline-form-active') as HTMLElement;
                    (parentElement.querySelector('.inline-form-rating') as HTMLInputElement).value = (event.currentTarget as HTMLInputElement).value;
                    //inlineRating.value = (event.currentTarget as HTMLInputElement).value;
                });
            });
        }
    }

    requestPRMSubmit(dataAttribute: object): void {
        let brand = dataAttribute['brand'],
            locale = dataAttribute['locale'],
            language=locale.split("-")[0].toUpperCase(),
            country=locale.split("-")[1].toUpperCase();

        axios({
            method: 'post',
            url: config.url + '/review/' + brand + '/' + locale + '/signUp',
            data:
            {
                configuration  :{
                      x_api_key: dataAttribute['x_api_key'],
                      region:dataAttribute['region']

                  },
                  profile: {
                    header: {
                      isoLanguage:language,
                      isoCountry: country,
                      brandCode :  dataAttribute['brandCode'],
                      campaignId:  dataAttribute['campaignId'],
                      origin: "Website",
                      formType: "signUp",
                      entity: "PRM2.6"
                    },
                    consumerIdentity: {
                      firstName: dataAttribute['firstname'],
                      lastName: dataAttribute['lastname']
                    },
                    contactDetail: {
                      "email": dataAttribute['email']
                    },
                    optInStatus: {
                      brandEmailConsent: dataAttribute['brandOptin'],
                      ...(locale.toLowerCase() === 'it-it' 
                    ? { unileverEmailOnlyConsent: dataAttribute['unileverOptin'], unileverOnlineOnlyConsent: dataAttribute['unileverOptin'] }
                    : { unileverEmailConsent: dataAttribute['unileverOptin'] }),
                      legalAgeConsent: dataAttribute['termAndConditions']
                    }
                  }
                },
            headers: {
                'x-api-key': brandConfig.apikey
            },
            validateStatus: function (status) {
                return status >= 200 && status <= 400; // default; // Resolve only if the status code is less than 500
            }
        }).then(()=>{
            return;
        }).catch((error)=>{
            console.log("error", error);
        })
    }

    checkFormValidation(formData, element): boolean{
        let validations=[],
            patEmail = /^([\w\!\#$\%\&\'\*\+\-\/\=\?\^\`{\|\}\~]+\.)*[\w\!\#$\%\&\'\*\+\-\/\=\?\^\`{\|\}\~]+@((((([a-zA-Z0-9]{1}[a-zA-Z0-9\-]{0,62}[a-zA-Z0-9]{1})|[a-zA-Z])\.)+[a-zA-Z]{2,6})|(\d{1,3}\.){3}\d{1,3}(\:\d{1,5})?)$/;
        if((formData.hasOwnProperty('contributor') && formData['contributor'].hasOwnProperty('nickName') && formData['contributor']['nickName'].length < defaultConfig.fieldValidation.nickName.length) && defaultConfig.requiredFields.indexOf('nickName')>=0) {
            validations.push('nickName');
        }
        if((formData.hasOwnProperty('contributor') && formData['contributor'].hasOwnProperty('nickName') && formData['contributor']['nickName'].length > defaultConfig.fieldValidation.nickName.max) && defaultConfig.requiredFields.indexOf('nickName')>=0) {
            validations.push('nickNameMax');
        }
        if(formData.hasOwnProperty('brandOptin') || formData['brandOptin']) {
            if((formData.hasOwnProperty('contributor')
                && formData['contributor'].hasOwnProperty('email')
                && !patEmail.test(formData['contributor']['email']))
                && defaultConfig.requiredFields.indexOf('email')>=0) {
                if(formData['contributor']['email'].length){
                    validations.push('inCorrectEmail');
                } else {
                    validations.push('email');
                }
            }
        } else if((!formData.hasOwnProperty('brandOptin')
            && formData.hasOwnProperty('contributor')
            && formData['contributor'].hasOwnProperty('email')
            && !patEmail.test(formData['contributor']['email']))
            && defaultConfig.requiredFields.indexOf('email')>=0) {
            if(formData['contributor']['email'].length){
                validations.push('inCorrectEmail');
            } else {
                validations.push('email');
            }
        }else if(formData.hasOwnProperty('contributor') 
            && formData['contributor']['email'] 
            && defaultConfig.quesRequiredFields.indexOf('email')>=0
            && formData['contributor']['email'].length > defaultConfig.fieldValidation.email.max) {
            validations.push('emailMax');
        }

        if((formData.hasOwnProperty('termAndConditions') && formData['termAndConditions'] === defaultConfig.fieldValidation.termAndConditions.value) && defaultConfig.requiredFields.indexOf('termAndConditions')>=0) {
            validations.push('termAndConditions');
        }
        if((formData.hasOwnProperty('firstname') && formData['firstname'].length === defaultConfig.fieldValidation.firstName.length) && defaultConfig.requiredFields.indexOf('firstName')>=0) {
            validations.push('firstName');
        }
        if((formData.hasOwnProperty('lastname') && formData['lastname'].length === defaultConfig.fieldValidation.lastName.length) && defaultConfig.requiredFields.indexOf('lastName')>=0) {
            validations.push('lastName');
        }

        let errorFlag= this.showErrorMessage(validations, element);
        return errorFlag;
    }

    checkReviewFormValidation(formData, element): boolean{
        let validations=[],
            patEmail = /^([\w\!\#$\%\&\'\*\+\-\/\=\?\^\`{\|\}\~]+\.)*[\w\!\#$\%\&\'\*\+\-\/\=\?\^\`{\|\}\~]+@((((([a-zA-Z0-9]{1}[a-zA-Z0-9\-]{0,62}[a-zA-Z0-9]{1})|[a-zA-Z])\.)+[a-zA-Z]{2,6})|(\d{1,3}\.){3}\d{1,3}(\:\d{1,5})?)$/;
        if((formData['rating'] === "" || formData['rating'] === defaultConfig.fieldValidation.rating.value) && defaultConfig.requiredFields.indexOf('rating')>=0) {
            validations.push('rating');
        }
        if((formData.hasOwnProperty('reviewTitle') && formData['reviewTitle'].length === defaultConfig.fieldValidation.title.length) && defaultConfig.requiredFields.indexOf('reviewTitle')>=0) {
            validations.push('title');
        }
        if((formData.hasOwnProperty('reviewTitle') && formData['reviewTitle'].length > defaultConfig.fieldValidation.title.max) && defaultConfig.requiredFields.indexOf('reviewTitle')>=0) {
            
            validations.push('titleMax');
        }
        if((formData.hasOwnProperty('reviewComment') && formData['reviewComment'].length < defaultConfig.fieldValidation.comment.min) && defaultConfig.requiredFields.indexOf('reviewComment')>=0) {
            validations.push('commentMin');
        }
        if((formData.hasOwnProperty('reviewComment') && formData['reviewComment'].length > defaultConfig.fieldValidation.comment.max) && defaultConfig.requiredFields.indexOf('reviewComment')>=0) {
            validations.push('commentMax');
        }

        let errorFlag= this.showReviewErrorMessage(validations, element);
        return errorFlag;
    }

    showReviewErrorMessage(validations, element: HTMLElement): boolean{
        let $rRatingError = element.querySelector('.kr-inline-form-active .kr-inline-rating-error'),
        $rTitleError = element.querySelector('.kr-inline-form-active .kr-inline-title-error'),
        $rTitleMaxError = element.querySelector('.kr-inline-form-active .kr-inline-titlemax-error'),
        $rCommentMinError = element.querySelector('.kr-inline-form-active .kr-inline-comment-min-error'),
        $rCommentMaxError = element.querySelector('.kr-inline-form-active .kr-inline-comment-max-error'),
        $rRating = element.querySelector('.kr-inline-form-active .kr-inline-review-1'),
        $rTitle = element.querySelector('.kr-inline-form-active .kr-inline-reviewTitle'),
        $rComment = element.querySelector('.kr-inline-form-active .kr-inline-reviewTxt'),
        $rSubmissionForm = element.querySelector('.kr-submission-form'),
        errorSelector = [];
        if(validations.length>0) {
            if (validations.indexOf('rating')>=0) {
                $rRatingError.classList.remove('kr-hide');
                $rRatingError.classList.add('show');
                errorSelector.push($rRatingError);
                inlineWidget.prototype.updateReviewInputMessage($rRating as HTMLInputElement, $rRatingError as HTMLElement, true);
            } else if($rRatingError) {
                $rRatingError.classList.remove('show');
                $rRatingError.classList.add('kr-hide');
            }
            if (validations.indexOf('title')>=0) {
                $rTitleError.classList.remove('kr-hide');
                $rTitleError.classList.add('show');
                $rTitle.classList.add('error-focus');
                errorSelector.push($rTitleError);
                inlineWidget.prototype.updateReviewInputMessage($rTitle as HTMLInputElement, $rTitleError as HTMLElement);
            } else if($rTitleError) {
                $rTitleError.classList.remove('show');
                $rTitleError.classList.add('kr-hide');
                $rTitle.classList.remove('error-focus');
            }
            if (validations.indexOf('titleMax')>=0) {
                $rTitleMaxError.classList.remove('kr-hide');
                $rTitleMaxError.classList.add('show');
                $rTitle.classList.add('error-focus');
                errorSelector.push($rTitleMaxError);
                inlineWidget.prototype.updateReviewInputMessage($rTitle as HTMLInputElement, $rTitleMaxError as HTMLElement);
            } else if($rTitleMaxError) {
                $rTitleMaxError.classList.remove('show');
                $rTitleMaxError.classList.add('kr-hide');
                $rTitle.classList.remove('error-focus');
            }
            if (validations.indexOf('commentMin')>=0) {
                let countOfCharactar = inlineWidget.prototype.getCountMessage($rComment as HTMLInputElement, element);
                errorSelector.push($rCommentMinError);
                if(countOfCharactar<defaultConfig.fieldValidation.comment.min){
                    // $rCommentMinError.innerHTML = defaultConfig.fieldValidationMessage.commentMin;
                    $rCommentMinError.classList.add('show');
                    $rCommentMinError.classList.remove('kr-hide');
                    $rComment.classList.add('error-focus');
                };
            } else if (validations.indexOf('commentMax')>=0) {
                let countOfCharactar = inlineWidget.prototype.getCountMessage($rComment as HTMLInputElement, element);
                errorSelector.push($rCommentMinError);
                if(countOfCharactar>defaultConfig.fieldValidation.comment.max){
                    // $rCommentMinError.innerHTML = defaultConfig.fieldValidationMessage.commentMax;
                    $rCommentMaxError.classList.add('show');
                    $rCommentMaxError.classList.remove('kr-hide');
                    $rComment.classList.add('error-focus');
                };
            }
            if(errorSelector[0].parentNode.querySelector('textarea')){
                $rSubmissionForm.classList.add('is-invalid');
                errorSelector[0].parentNode.querySelector('textarea').focus();
            }
            else {
                $rSubmissionForm.classList.add('is-invalid');
                if(errorSelector[0] && errorSelector[0].parentNode && errorSelector[0].parentNode.querySelector('input')) {
                    errorSelector[0].parentNode.querySelector('input').focus();
                }
            }
            return false;
        } else {
            $rSubmissionForm.classList.remove('is-invalid');
            return true;
        }
    }

    showErrorMessage(validations, element): boolean{
        let $rEmailError = element.querySelector('.kr-inline-email-error'),
        $rEmailMaxError = element.querySelector('.kr-inline-emailmax-error'),
        $rIncorrectEmailError = element.querySelector('.kr-inline-incorrect-email-error'),
        $rNnameError = element.querySelector('.kr-inline-nickname-error'),
        $rNnameMaxError = element.querySelector('.kr-inline-nicknamemax-error'),
        $rFnameError = element.querySelector('.kr-inline-firstname-error'),
        $rTnCError = element.querySelector('.kr-inline-termandconditions-error'),
        $rLnameError = element.querySelector('.kr-inline-lastname-error'),
        $rRating = element.querySelector('.kr-inline-review-1'),
        $rTitle = element.querySelector('.kr-inline-reviewTitle'),
        $rComment = element.querySelector('.kr-inline-reviewTxt'),
        $rNickname = element.querySelector('.kr-inline-nckName'),
        $rEmail = element.querySelector('.kr-inline-email'),
        $rFirstname = element.querySelector('.kr-inline-firstName'),
        $rLastname = element.querySelector('.kr-inline-lastName'),
        $rSubmissionForm = element.querySelector('.kr-submission-form'),
        errorSelector = [];
        if(validations.length>0) {
            if (validations.indexOf('nickName')>=0) {
                $rNnameError.classList.remove('kr-hide');
                $rNnameError.classList.add('show');
                errorSelector.push($rNnameError);
                $rNickname.classList.add('error-focus');
                inlineWidget.prototype.updateReviewInputMessage($rNickname as HTMLInputElement, $rNnameError as HTMLElement);
            } else if($rNnameError) {
                $rNnameError.classList.remove('show');
                $rNnameError.classList.add('kr-hide');
                $rNickname.classList.remove('error-focus');
            }
            if (validations.indexOf('nickNameMax')>=0) {
                $rNnameMaxError.classList.remove('kr-hide');
                $rNnameMaxError.classList.add('show');
                errorSelector.push($rNnameMaxError);
                $rNickname.classList.add('error-focus');
                inlineWidget.prototype.updateReviewInputMessage($rNickname as HTMLInputElement, $rNnameMaxError as HTMLElement);
            } else if($rNnameMaxError) {
                $rNnameMaxError.classList.remove('show');
                $rNnameMaxError.classList.add('kr-hide');
                $rNickname.classList.remove('error-focus');
            }
            if (validations.indexOf('email')>=0) {
                $rEmailError.classList.remove('kr-hide');
                $rEmailError.classList.add('show');
                if(!$rIncorrectEmailError.classList.contains('kr-hide')) {
                    $rIncorrectEmailError.classList.add('kr-hide');
                }
                if(!$rEmailMaxError.classList.contains('kr-hide')) {
                    $rEmailMaxError.classList.add('kr-hide');
                }
                $rEmail.classList.add('error-focus');
                errorSelector.push($rEmailError);
                inlineWidget.prototype.updateReviewInputMessage($rEmail as HTMLInputElement, $rEmailError as HTMLElement);
            } else if(validations.indexOf('inCorrectEmail') >= 0 ) {
                $rIncorrectEmailError.classList.remove('kr-hide');
                $rIncorrectEmailError.classList.add('show');
                $rEmailError.classList.add('kr-hide');
                $rEmail.classList.add('error-focus');
                errorSelector.push($rEmailError);
            }else if(validations.indexOf('emailMax') >= 0 ) {
                $rEmailError.classList.add('kr-hide');
                $rIncorrectEmailError.classList.add('kr-hide');
                $rEmailMaxError.classList.remove('kr-hide');
                $rEmailMaxError.classList.add('show')
                $rEmail.classList.add('error-focus');
                errorSelector.push($rEmailMaxError);
            } else if($rIncorrectEmailError){
                $rIncorrectEmailError.classList.remove('show');
                $rIncorrectEmailError.classList.add('kr-hide');
                $rEmail.classList.remove('error-focus');
            }
            if (validations.indexOf('termAndConditions')>=0) {
                $rTnCError.classList.remove('kr-hide');
                $rTnCError.classList.add('show');
                errorSelector.push($rTnCError);
            } else if($rTnCError){
                $rTnCError.classList.remove('show');
                $rTnCError.classList.add('kr-hide');
            }
            if (validations.indexOf('firstName')>=0) {
                $rFnameError.classList.remove('kr-hide');
                $rFnameError.classList.add('show');
                $rFirstname.classList.add('error-focus');
                errorSelector.push($rFnameError);
                inlineWidget.prototype.updateReviewInputMessage($rFirstname as HTMLInputElement, $rFnameError as HTMLElement);
            } else if($rFnameError){
                $rFnameError.classList.remove('show');
                $rFnameError.classList.add('kr-hide');
                $rFirstname.classList.remove('error-focus');
            }
            if (validations.indexOf('lastName')>=0) {
                $rLnameError.classList.remove('kr-hide');
                $rLnameError.classList.add('show');
                $rLastname.classList.add('error-focus');
                errorSelector.push($rLnameError);
                inlineWidget.prototype.updateReviewInputMessage($rLastname as HTMLInputElement, $rLnameError as HTMLElement);
            } else if($rLnameError){
                $rLnameError.classList.remove('show');
                $rLnameError.classList.add('kr-hide');
                $rLastname.classList.remove('error-focus');
            }
            //errorSelector[0].parentNode.scrollIntoView({behavior: 'smooth', block: 'start'});
            if(errorSelector[0].parentNode.querySelector('textarea')){
                $rSubmissionForm.classList.add('is-invalid');
                errorSelector[0].parentNode.querySelector('textarea').focus();
            }
            else {
                $rSubmissionForm.classList.add('is-invalid');
                if(errorSelector[0] && errorSelector[0].parentNode && errorSelector[0].parentNode.querySelector('input')) {
                    errorSelector[0].parentNode.querySelector('input').focus();
                }
            }
            return false;
        } else {
            $rSubmissionForm.classList.remove('is-invalid');
            return true;
        }
    }

    thanksMessage(nickNameData: string): void{
        
    }


    getMediaDataForUploadedImages(brand,locale,entityId): Promise<any> {
        try {
            return new Promise(async (resolve) => {
                let self= this,
                    reviewMedia = [];
                for (let item of this.allUploadedMedia) {
                    self.mediaUploadToSanity(brand,locale,entityId,item.file).then((imageAsset)=>{
                        reviewMedia.push({
                            type: 'image',
                            url: imageAsset,
                            caption: item.caption,
                            thumbnailURL: imageAsset
                        });
                        if(reviewMedia.length == this.allUploadedMedia.length) {
                            resolve(reviewMedia);
                        }
                    });
                }
            })
        }catch (e) {
            console.error(e);
        }
    }

    mediaUploadToSanity = async (brand,locale,entityId,filePath: File) => {

        let file = new FormData();
        file.append('file', filePath, filePath.name);
        
        const Apiurl = `${config.url}/reviews/${brand}/${locale}/${entityId}/uploadMedia`

        const uploadFile = await axios.post(Apiurl, file, {headers: {
            'x-api-key': brandConfig.apikey
        }})
        console.log(uploadFile, 'inline uploaded file')
        return uploadFile.data
    }

}